import { IMedia, IPhoto } from '@/types/interfaces';
import { PHOTO_VIEW_TYPE } from '@/types/enums';

export default function clearPhotoCache(media: IMedia): void {
  URL.revokeObjectURL(process.env.VUE_APP_MEDIA_URL + media.previewUrl);
  URL.revokeObjectURL(`${process.env.VUE_APP_MEDIA_URL + media.fileUrl}/HEIGHT`);
  URL.revokeObjectURL(`${`${process.env.VUE_APP_MEDIA_URL}/${media.fileUrl}`}/HEIGHT`);
  URL.revokeObjectURL(`${process.env.VUE_APP_MEDIA_URL + media.fileUrl}/WIDTH`);
  URL.revokeObjectURL(`${`${process.env.VUE_APP_MEDIA_URL}/${media.fileUrl}`}/WIDTH`);

  // eslint-disable-next-line no-param-reassign
  media.previewUrl = `${media.previewUrl}?t=${(new Date()).getTime()}`;
  // eslint-disable-next-line no-param-reassign
  media.fileUrl = `${media.fileUrl}?t=${(new Date()).getTime()}`;
}

export function clearPhotoCache2(photo: IPhoto) {
  const photoUrl = process.env.VUE_APP_MEDIA_URL + photo.url;
  const viewTypes = Object.values(PHOTO_VIEW_TYPE);

  URL.revokeObjectURL(photoUrl);
  viewTypes.forEach((viewType: PHOTO_VIEW_TYPE) => {
    URL.revokeObjectURL(`${photoUrl}/${viewType}`);
  });

  // eslint-disable-next-line no-param-reassign
  photo.url = `${photo.url}?t=${(new Date()).getTime()}`;
}
